<template>
  <a-layout class="base-layout">
    <a-layout-sider
      v-model="collapsed"
      :trigger="null"
      collapsible
      width="256"
      class="base-layout-sider"
    >
      <div class="logo">
        <img :src="logoUrl" alt="" class="logo-img" />
        <h1>信用系统</h1>
      </div>
      <SideMenu :collapsed="collapsed"></SideMenu>
    </a-layout-sider>
    <a-layout class="layout">
      <a-layout-header class="base-layout-header">
        <LayoutHeader :collapsed="collapsed"></LayoutHeader>
      </a-layout-header>
      <a-layout-content>
        <LayoutContent />
      </a-layout-content>
      <a-layout-footer style="text-align: center">
        联想信用管理系统v3.4 | 北京联想金服科技有限公司
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script>
import SideMenu from './SideMenu'
import LayoutHeader from './LayoutHeader'
import LayoutContent from './LayoutContent'
import storge from 'good-storage'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('app', ['collapsed', 'logoUrl']),
  },
  mounted() {
    const isWelcomeMessage = storge.get('isWelcomeMessage') || false

    if (!isWelcomeMessage) {
      this.welcomeMessage()
      storge.set('isWelcomeMessage', true)
    }
  },
  components: { SideMenu, LayoutHeader, LayoutContent },
  methods: {
    welcomeMessage() {
      let message = '你好！欢迎回来'

      this.$notification.open({
        message: '欢迎',
        description: message,
        key: 'login',
        icon: h =>
          h('a-icon', {
            props: { type: 'smile' },
            style: { color: '#108ee9' },
          }),
      })
    },
  },
}
</script>

<style lang="less" scoped>
.base-layout {
  min-height: 100%;

  .base-layout-sider {
    box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
    z-index: 3;
    overflow: auto;
    // height: 100vh;
    // position: fixed;
    left: 0;
  }

  .base-layout-header {
    height: 64px;
    background: #fff;
    padding: 0;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    z-index: 2;
  }

  .logo {
    height: 64px;
    line-height: 64px;
    padding-left: 24px;
    overflow: hidden;

    img {
      display: inline-block;
      vertical-align: middle;
      width: 40px;
      height: 40px;
    }

    h1 {
      display: inline-block;
      color: #fff;
      line-height: 64px;
      font-size: 20px;
      margin: 0 0 0 20px;
      font-weight: bold;
      vertical-align: middle;
    }
  }
}
</style>
